import { render, staticRenderFns } from "./demensionFilter.vue?vue&type=template&id=f6c7083a&scoped=true&"
import script from "./demensionFilter.vue?vue&type=script&lang=js&"
export * from "./demensionFilter.vue?vue&type=script&lang=js&"
import style0 from "./demensionFilter.vue?vue&type=style&index=0&id=f6c7083a&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c7083a",
  null
  
)

export default component.exports